import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";

const SPPPsList = ({ globalContext }) => {


    return <>

        <GenericDataTable
            columns={[
                
                {
                    key: "Establishment",
                    label: "SPPP",
                    sortable: true,
                    size: "250px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            <a
                                //href={`/your-medboard/country-registrations/product-portfolio/product-portfolio-filter/?mode=12&filter=${row.EstablishmentId}`}
                                href={`/your-medboard/products/?filter[SPPPs]=${row.EstablishmentId}`}
                                style={{
                                    color: "#203864",
                                    textDecoration: "none",
                                }}
                            >
                                {value}
                            </a>
                        </div>
                    ),
                },

                {
                    key: "Count",
                    label: "No. of Products",
                    sortable: true,
                    size: "150px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {value}
                        </div>
                    ),
                },
            ]}
            fetchUrl="/umbraco/api/RIMSProducts/OperatorsProducts/"
            enableDelete={false}
            enableExport={false}
            //deleteUrl="/umbraco/api/RIMSProducts/BulkProducts/"
            //exportUrl="/umbraco/api/RIMSProducts/ProductsExport/"
            queryParams={{roleId: 9}}
            //exportFileName={`country-registrations-totals-export.xlsx`}
            rowTitleKey="Establishment"
            searchPlaceholder="Search"
            LoadingComponent={LoadingSpinnerImage}
            showTotalCount={true}
            totalCountUrl="/umbraco/api/RIMSProducts/OperatorsProductsCount/?roleId=9"
        />

    </>


}

export default SPPPsList;